/**
 * Names of all script functions.
 *
 * @module
 */

/** Script function type for `0x1::coin::transfer`. */
export const transfer = "0x1::coin::transfer" as const;
